module.exports = __webpack_public_path__ + "img/BOTON-ANTERIOR-OVER.110c4d59.svg";